/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import _ from 'lodash';

import { UseUpdateClusterData } from '../../../../../../components/hooks/useUpdateCluster';
import { formatMaintenanceWindow } from '../../../../../../containers/CreateClusterOverlay/utils';
import { ChangePlanFormValues } from './ChangePlanForm.types';

export const createUpdateClusterData = (values: ChangePlanFormValues, parameters: any): UseUpdateClusterData => {
  const suggestionsConfig = Object.entries(values.suggestedPgConfigParameters ?? {}).filter(
    ([, value]) => value !== undefined,
  );

  return {
    data: {
      configuration: {
        replicas: values.replicas,
        supportPlanId: values.supportPlanId,
        cpuUnits: values.cpuUnits,
        memoryGbs: values.memoryGbs,
        storageGbs: values.storageGbs,
        postgresqlConfig: suggestionsConfig.length
          ? suggestionsConfig.reduce((acc, [path, value]) => _.set(acc, path, value), parameters)
          : undefined,
        maintenanceWindows: values.maintenanceWindows.map(formatMaintenanceWindow),
      },
    },
  };
};
